"use client"

import React,{useState} from 'react'
import {FiUpload} from 'react-icons/fi'
import {IoClose} from 'react-icons/io5'
import {FiChevronRight} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import ErrorComponent from '../folder/constants/ErrorComponent';
import axios from 'axios'
import { base_url, department } from '../folder/constants/Appconstants';
import {message} from 'antd'

import { FaCheckCircle } from "react-icons/fa";

function Joinus() { 
   
  const [step,setstep] = useState(1) 
  const navigator = useNavigate()

  const [data,setdata] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
  const [error,seterror] = useState({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})

  function handleChange(e){
    setdata({...data,[e.target.name]:e.target.value})
    seterror({...error,[e.target.name]:''})
  } 

  async function submitForm(){
    if(!data?.name){
      seterror({...error,name:'This Field is required *'})
    }else if(!data?.mobile && data.mobile.length < 10){
      seterror({...error,mobile:'This Field is required *'})
    }else if(!data?.email){
      seterror({...error,email:'This Field is required *'})
    }else if(!data?.experience){
      seterror({...error,experience:'This Field is required *'})
    }else if(!data?.file){
      seterror({...error,file:'This Field is required *'})
    }else{

      const fd = new FormData()
      fd.append('name',data?.name)
      fd.append('mobile',data?.mobile)
      fd.append('email',data?.email)
      fd.append('experience',data?.experience)
      fd.append('previous_company',data?.previous_company)
      fd.append('query',data?.query)
      fd.append('file',data?.file)
      fd.append('department_website',department)

      const headers = {headers:{
        'Content-Type':'multipart/form-data'
      }}
      
      await axios.post(`${base_url}applicant/create`,fd,headers)
      .then((res)=>{
        if(res?.status === 201){
          message.success('Form Submitted Successfully')
          setdata({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
          seterror({name:'',mobile:'',email:'',experience:'',previous_company:'',query:'',file:''})
        }
      }).catch((err)=>{      
      }) 
    }
  }

  
  
 




  const [selected_departments,setselected_departments] = useState('')
  
  return (
    <div className="w-full relative  h-full overflow-hidden">
     <div className='relative h-[30vh] md:min-h-[60vh] md:max-h-[60vh] relative bg-carriers-bg bg-cover bg-no-repeat bg-center'>
          
          <div className='absolute  top-[6%] left-[10%]'>
          <h6 className='font_normal group text-white text-[13px] flex items-center'><span onClick={()=>navigator('/')} className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Home</span> <FiChevronRight className='mx-2' />  <span className='opacity-70 hover:opacity-100 hover:underline cursor-pointer'>Join Us</span>  </h6>  
          </div>
          <h1 className='text-white flex font_normal text-[13px] p-6 bg-black px-10 md:text-[16px] absolute bottom-0 left-[10%] bg-opacity-70'><span className='min-w-[4px] block min-h-[18px] max-h-[35px] rounded mt-[-1px] mr-4 bg-[#fff]'></span> Join the fidelitus martian army and became an industry expert service provider</h1>
        </div>

      <div className='w-[90%] min-h-[60vh] mx-auto my-10'>
       
       <div className='w-[90vw] md:w-[80vw] mx-auto'>
          <h1 data-aos="fade-left" className='font_bold relative text-[20px] text-center ' >Join Us</h1>
            <div data-aos="fade-right" className='flex items-center justify-center mt-2'>
            <h1  className='font_normal  relative min-w-[100px] max-w-[100px] min-h-[3px] max-h-[3px] bg-[#027d9b]' ></h1>
            </div> 
        </div>

        <h1 data-aos="fade-up" className='font_normal relative text-[14px] mt-2 text-center pb-10' >If you would like to join the fidelitus martian army just complete the below form to get updates!.</h1>
        
        <div className='md:flex items-center justify-between'>
          <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>
                    <h6 className='ml-1 text-[26px] font_normal font-[700] w-[100%] md:w-[70%]'>Looking to Join our Family as an Fidelitus Employee.</h6>

                    <h6 className=' mt-5 text-gray-600 font_normal w-[100%]  mx-auto text-[14px]'>Contact us and you&apos;ll receive a call as soon as you get shortlisted </h6>
                    <div className='mt-5 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Name</h6>
                  <input type='text' name="name" value={data?.name} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 text-[13px]' />
                </div>

                <ErrorComponent error={error?.name} />

                <div className='mt-2 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Mobile</h6>
                  <input type='text' name="mobile" value={data?.mobile} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 text-[13px]' />
                </div>
                <ErrorComponent error={error?.mobile} />


                <div className='mt-2 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Email</h6>
                  <input type='text' name="email" value={data?.email} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 text-[13px]' />
                </div>
                <ErrorComponent error={error?.email} />


                <div className='mt-2 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Experience</h6>
                  <input min={0} name="experience" value={data?.experience} onChange={handleChange} type='number' className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 text-[13px]' />
                </div>

                <ErrorComponent error={error?.experience} />



                <div className='mt-2 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Previous Company</h6>
                  <input type='text'  name="previous_company" value={data?.previous_company} onChange={handleChange} className='border w-full focus:ring-0 focus:outline-none p-1 pl-2 text-[13px]' />
                </div>


                <div className='mt-2 w-full'>
                  <h6 className='mb-1 text-[13px]'>Upload Resume</h6>
                  {data?.file === '' ? 
                  <form onClick={()=>document.querySelector('.input-field').click()} className={`p-4 flex flex-col items-center justify-center cursor-pointer rounded   border-dashed border`}>
                    <FiUpload size={24} />
                    <span className='font-bold font_normal text-[10px] mt-1 text-center'>Click To Upload Photo</span>
                    <span className='font-bold font_normal text-[7px] mt-0 text-center'>Supported Type JPEG,PNG,SVG,WEBP</span>
                    <input type='file' onChange={({target:{files}})=>{
                      files[0] && setdata({...data,file:files[0]});seterror({...error,file:''})
                    }} accept="image/*" className='input-field' hidden />
                </form> 
                  :
                  <div className='flex border relative p-2'>
                      <h6 className='text-[13px] font_normal truncate w-[95%] pl-2'>{data?.file?.name}</h6>
                      <IoClose className='absolute  right-2' onClick={()=>{setdata({...data,file:''});seterror({...error,file:''})}}/>
                  </div>  
                  }

                </div>

                <ErrorComponent error={error?.file} />


                <div className='mt-2 w-full'>
                  <h6 className='mb-1 font_normal text-[13px]'>Query</h6>
                  <textarea name="query" value={data?.query} onChange={handleChange} type='text' className='border w-full focus:ring-0 focus:outline-none p-1' />
                </div>


                    <button onClick={submitForm} className='text-[12px] flex font_normal mt-2 items-end justify-end bg-black text-white p-2'>
                      SUBMIT
                    </button>

          </div>

          <div data-aos="fade-up" className='md:mt-10 md:w-[48%]'>

            <h6 className='font_bold text-[18px] my-5'>Advantages you will recieve</h6>
             
            <h1  className='font_normal  relative min-w-[100px] max-w-[100px] min-h-[3px] max-h-[3px] bg-[#027d9b]' ></h1>

             <div className='grid mt-10 grid-cols-2'>
            <div className='p-4 border-r border-b '>
              <h6 className='font-[700] font_normal flex items-center'> Fast Growing <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> We are at an inflection point to achieve accelarated!. </h6>
            </div>

            <div className='p-4 border-b '>
              <h6 className='font-[700] font_normal flex items-center'> Great Collegues <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> Closely tied and supportive team!. </h6>
            </div>

            <div className='p-4 border-r border-b '>
              <h6 className='font-[700] font_normal flex items-center'> Take Charge <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> AS much as you are willing to take ans show excellence!. </h6>
            </div>

            <div className='p-4 border-b '>
              <h6 className='font-[700] font_normal flex items-center'> Don't stop learning <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> An atmosphere where learning is always on the to do list!. </h6>
            </div>

            <div className='p-4 border-r  '>
              <h6 className='font-[700] font_normal flex items-center'> Latest Technology Stack <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> Working experience of cutting edge technologies!. </h6>
            </div>

            <div className='p-4 '>
              <h6 className='font-[700] font_normal flex items-center'> Cross domain exposure <FaCheckCircle className='text-[#4190ac] ml-2' /> </h6>
              <h6 className='font-[400] text-[13px] text-gray-400'> Highly passionate and cohesive team of technology and business people!. </h6>
            </div>
            </div>


          
          </div>
        </div>

      </div>
    </div>
  )
}

export default Joinus